import { useContext, useRef, useState } from "react";
import { chooseFileIcon } from "../../../assets/icons";
import styles from "./additionalDocuments.module.css";
import { WizardContext } from "../../../Store/Wizard.store";

interface AdditionalDocumentsProps {
    uploadedFiles: string[];
    onFileUpload: (fileName: string) => void;
}

export default function AdditionalDocuments({uploadedFiles, onFileUpload}: AdditionalDocumentsProps) {
  const { wizardFormData, setWizardFormData } = useContext(WizardContext);
  const [additionalDocumentText, setAdditionalDocumentText] = useState("Upload additional document");
    const additionalDocumentRef = useRef<HTMLInputElement>(null);
    
    const updateAdditionalDocumentText = () => {
        if ( additionalDocumentRef.current?.files && additionalDocumentRef.current.files.length > 0 ) {
            const fileName = additionalDocumentRef.current.files[0].name;
            if (uploadedFiles.includes(fileName)) {
              alert("A file with this name has already been uploaded.");
              additionalDocumentRef.current != null ? additionalDocumentRef.current.value = "" : null;
              setAdditionalDocumentText("Upload additional document");
            } else {
              setAdditionalDocumentText(fileName);
              if (wizardFormData.adData.additionalDocuments != undefined) { 
                setWizardFormData({
                  ...wizardFormData,
                  adData: {
                    ...wizardFormData.adData,
                    additionalDocuments: [...wizardFormData.adData.additionalDocuments, {
                      fileData: additionalDocumentRef.current.files[0],
                      fileName: additionalDocumentRef.current.files[0].name,
                      mimeType: '',
                      id: 0
                    }]
                  },
                });
              }else {
                setWizardFormData({
                  ...wizardFormData,
                  adData: {
                    ...wizardFormData.adData,
                    additionalDocuments: [{
                      fileData: additionalDocumentRef.current.files[0],
                      fileName: additionalDocumentRef.current.files[0].name,
                      mimeType: '',
                      id: 0
                    }]
                  },
                });
              }
              onFileUpload(fileName);
            }
        } else {
            setAdditionalDocumentText("Upload additional document");
            setWizardFormData({
              ...wizardFormData,
              adData: {
                ...wizardFormData.adData,
                additionalDocuments: [{
                  fileData: new File([""], ""),
                  fileName: '',
                  mimeType: '',
                  id: 0
                }]
              },
            });
        }
      };

    return(
        <div style={{display: "inline-flex"}} data-document={additionalDocumentText}>
            <label htmlFor="additionalDocument">additional document</label>
            <input
              ref={additionalDocumentRef}
              type="file"
              name="additionalDocument"
              id="additionalDocument"
              accept=".docx, .xls, .csv, .pdf"
              onChange={() => updateAdditionalDocumentText() }
              />
            <div className={styles.upload_container}>
              <i>{chooseFileIcon}</i>
              <button type="button" onClick={() => additionalDocumentRef.current?.click()}>
                {additionalDocumentText}
              </button>
            </div>
        </div>
    )
}